export default "__VITE_ASSET__CTd6WnlR__"